export default __webpack_public_path__ + "static/media/check-circle-blue.43fc32b7.svg";